const initialState = {
  submitting: false,
  successful: false,
  forPolicy: null,
  previousPolicy: null,
  uploadCategory: null, // null or object defined in getUploadCategories
  shortNote: null,
  isUploadCategoryOpen: false,
  files: [],
  forceResetOnMount: false,
}

export default function(state = initialState, action = {}) {
  switch (action.type) {
    case 'RESET_UPLOAD_FILES': {
      return initialState
    }

    case 'RESET_ALL_EXCEPT_POLICIES': {
      return {
        ...initialState,
        forPolicy: state.forPolicy,
        previousPolicy: state.previousPolicy,
      }
    }

    case 'SET_FORCE_RESET_ON_MOUNT': {
      return {
        ...state,
        forceResetOnMount: action.payload.forceResetOnMount,
      }
    }

    case 'SET_UPLOAD_FILE_PREVIOUS_POLICY': {
      return {
        ...state,
        previousPolicy: action.payload.previousPolicy,
      }
    }

    case 'SET_POLICY_FOR_UPLOAD_FILE': {
      return {
        ...state,
        forPolicy: action.payload.policy,
      }
    }

    case 'SET_IS_UPLOAD_CATEGORY_OPEN': {
      return {
        ...state,
        isUploadCategoryOpen: action.payload.isOpen,
      }
    }

    case 'SET_UPLOAD_CATEGORY': {
      return {
        ...state,
        uploadCategory: action.payload.uploadCategory,
      }
    }

    case 'SET_SHORT_NOTE': {
      return {
        ...state,
        shortNote: action.payload.shortNote,
      }
    }

    case 'ADD_FILE': {
      return {
        ...state,
        files: [...state.files, action.payload.file],
      }
    }

    case 'REMOVE_FILE': {
      return {
        ...state,
        files: state.files.filter(file => file.uid !== action.payload.uid),
      }
    }

    case 'SEND_FILE_UPLOAD': {
      return {
        ...state,
        submitting: true,
      }
    }

    case 'SEND_FILE_UPLOAD_COMMIT': {
      return {
        ...state,
        submitting: false,
        successful: true,
      }
    }

    case 'SEND_FILE_UPLOAD_ROLLBACK': {
      return {
        ...state,
        submitting: false,
        successful: false,
      }
    }

    default: {
      return state
    }
  }
}
